import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  Inject,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { FaturamentoRepository } from '@app/data/faturamento/faturamento.repository';
import { FaturamentoModel, ParcelaModel } from '@app/data/faturamento/models';
import { AnexoRepository } from '@data/anexo/anexo.repository';
import { AnexosComponent, AnexosOptions } from '@components/anexos/anexos.component';
import { Campo, FormComponent } from '@components/form/form.component';
import { modal } from '@shared/alerts/modal/modal.alert';
import { currencyBRL, dateFormat, dateOptionalFormat, parcelaSituacaoFormat, parcelaTipoQuitacaoFormat } from '@app/shared/formatters';

@Component({
  selector: 'app-detalhes-faturamento',
  templateUrl: './detalhes-faturamento.component.html',
  styleUrls: ['./detalhes-faturamento.component.scss'],
})
export class DetalhesFaturamentoComponent implements AfterContentChecked {

  protected loading: boolean = false;

  protected parcelasOriginais: ParcelaModel[] = [];
  protected parcelasPaginadas: ParcelaModel[] = [];
  protected parcelasPagination = {
    length: 0,
    pageSize: 5,
    pageIndex: 0,
  };

  protected camposDadosDetalhes: Campo[] = [
    {
      name: '',
      label: 'Fatura',
      type: 'separator',
    },
    {
      name: 'cliente.pessoa.razaoSocial',
      label: 'Cliente',
      type: 'text',
      disabled: true,
      width: '100%',
    },
    {
      name: 'fatura.numeroDocumento',
      label: 'Nº Documento',
      type: 'text',
      disabled: true,
      width: '50%',
    },
    {
      name: 'fatura.grupoContrato.numeroGrupoContrato',
      label: 'Contrato Master',
      type: 'text',
      disabled: true,
      width: '50%',
    },
    {
      name: 'dataEmissao',
      label: 'Data Emissão',
      type: 'date',
      disabled: true,
      width: '50%',
    },
    {
      name: 'dataVencimentoBase',
      label: 'Data Vencimento',
      type: 'date',
      disabled: true,
      width: '50%',
    },
    {
      name: 'fatura.contrato.veiculo.placa',
      label: 'Placa',
      type: 'text',
      disabled: true,
      width: '40%',
    },
    {
      name: 'fatura.contrato.veiculo.modelo.descricao',
      label: 'Modelo',
      type: 'text',
      disabled: true,
      width: '60%',
    },

    {
      name: '',
      label: 'Valores da Fatura',
      type: 'separator',
    },
    {
      name: 'valores',
      label: 'Itens',
      type: 'table',
      disabled: true,
      width: '100%',
      tableOptions: {
        items: [],
        colunas: [
          {
            name: 'tipoValor.descricao',
            label: 'Tipo Valor',
          },
          {
            name: 'valor',
            label: 'Valor',
            format: currencyBRL,
          },
        ]
      }
    },
    {
      name: '',
      label: 'Detalhes da Fatura',
      type: 'separator',
    },
    {
      name: 'fatura.corpo',
      label: 'Detalhes da Fatura',
      type: 'textarea',
      disabled: true,
      width: '100%',
    },
    {
      name: '',
      label: 'Detalhes do Recebimento',
      type: 'separator',
    },
    {
      name: 'parcelasPaginadas',
      label: 'Parcelas',
      type: 'table-with-footer',
      disabled: true,
      width: '100%',
      tableOptions: {
        colunas: [
          {
            name: 'numeroParcela',
            label: 'Número Parcela',
          },
          {
            name: 'dataVencimento',
            label: 'Data Vencimento',
            format: dateFormat,
          },
          {
            name: 'valorDocumento',
            label: 'Valor Documento',
            format: currencyBRL,
          },
          {
            name: 'situacao',
            label: 'Situação Recebimento',
            format: parcelaSituacaoFormat,
            icon: (item: ParcelaModel) => item.situacao === 'Q' ? 'check_circle' : 'cancel',
          },
          {
            name: 'tipoQuitacao',
            label: 'Tipo Quitação',
            format: parcelaTipoQuitacaoFormat,
          },
          {
            name: 'dataRecebimento',
            label: 'Data Recebimento',
            format: dateOptionalFormat,
          },
          {
            name: 'acoes',
            label: 'Ações',
            acoes: [
              {
                label: 'Copiar PIX',
                icon: 'content_copy',
                hidden: (item: ParcelaModel) => !item.codigoPix,
                action: (item: ParcelaModel) => this.copiarParaClipboard(item.codigoPix!),
              },
              {
                label: 'Copiar Linha Digitável',
                icon: 'content_copy',
                hidden: (item: ParcelaModel) => !item.linhaDigitavel,
                action: (item: ParcelaModel) => this.copiarParaClipboard(item.linhaDigitavel!),
              }
            ]
          },
        ],
        footerLabel: 'Total Recebimentos',
        footerColumns: [
          {
            name: 'valorDocumento',
            total: true,
            totalFormat: (value: number) => currencyBRL(value.toString()),
          },
        ],
      }
    },
    {
      name: 'parcelasPagination',
      label: '',
      type: 'paginator',
      disabled: true,
      width: '100%',
      paginatorOptions: {
        onPaginate: (event: PageEvent) => this.onParcelasPaginate(event)
      }
    },
  ];

  protected anexosOptions: AnexosOptions = {
    disableUpload: true,
  }

  @ViewChild('formDetalhes') formDetalhes: FormComponent | undefined;
  @ViewChild('anexos') anexos: AnexosComponent | undefined;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { id: string },
    private dialogRef: MatDialogRef<DetalhesFaturamentoComponent>,
    private changeDetector: ChangeDetectorRef,
    private anexoRepository: AnexoRepository,
    private faturamentoRepository: FaturamentoRepository,
  ) {}

  /** Para evitar erros em ambiente de desenvolvimento */
  public ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }

  public ngOnInit(): void {
    this.faturamentoRepository
      .getByIdRequest<{ data: FaturamentoModel }>(this.data.id)
      .subscribe(({ data }) => {
        if (data && this.formDetalhes) {
          const fatura =  (data.notaFiscal || data.notaDebito || data.recibo)!;

          this.parcelasOriginais = data.parcelas || [];
          this.parcelasPagination.length = this.parcelasOriginais.length;
          this.updateParcelasPaginadas();

          this.setAllItemsForParcelasTable();

          this.formDetalhes.load({
            ...data,
            fatura,
            parcelasPaginadas: this.parcelasPaginadas,
            parcelasPagination: this.parcelasPagination
          });

          this.anexoRepository.getAnexos('ContratosGrupos', fatura.contratoGrupoId).subscribe((data) => {
            if (this.anexos) {
              this.anexos.setSentFiles(data);
            }
          });
        }
      });
  }

  protected onParcelasPaginate(event: PageEvent) {
    this.parcelasPagination.pageIndex = event.pageIndex;
    this.parcelasPagination.pageSize = event.pageSize;

    this.updateParcelasPaginadas();

    this.setAllItemsForParcelasTable();

    if (this.formDetalhes) {
      this.formDetalhes.patchValue({
        parcelasPaginadas: this.parcelasPaginadas,
        parcelasPagination: this.parcelasPagination
      });
    }
  }

  protected copiarParaClipboard(valor: string) {
    if (valor) {
      navigator.clipboard.writeText(valor);
      modal.fire({
        icon: 'success',
        title: 'Sucesso!',
        html: 'Valor copiado para a área de transferência!',
        confirmButtonText: 'Continuar',
      });
    }
  }

  private updateParcelasPaginadas() {
    const startIndex = this.parcelasPagination.pageIndex * this.parcelasPagination.pageSize;
    const endIndex = startIndex + this.parcelasPagination.pageSize;
    this.parcelasPaginadas = this.parcelasOriginais.slice(startIndex, endIndex);
  }

  private setAllItemsForParcelasTable(): void {
    const parcelasTableField = this.camposDadosDetalhes.find(
      campo => campo.name === 'parcelasPaginadas'
    );

    if (parcelasTableField && parcelasTableField.tableOptions) {
      parcelasTableField.tableOptions.allItems = this.parcelasOriginais;
    }
  }

  protected imprimirFatura() {
    this.loading = true;

    this.faturamentoRepository.imprimirFatura(this.data.id).subscribe({
      next: ({ data }) => {
        const arrayBuffer = new Uint8Array(data.data);
        const file = new Blob([arrayBuffer], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      },
      error: (error) => {
        modal.fire({
          icon: error.icon,
          title: error.title,
          html: error.message,
        });
      },
    }).add(() => { this.loading = false });
  }

  protected imprimirBoleto() {
    this.loading = true;

    this.faturamentoRepository.imprimirBoleto(this.data.id).subscribe({
      next: ({ data }) => {
        const arrayBuffer = new Uint8Array(data.data);
        const file = new Blob([arrayBuffer], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      },
      error: (error) => {
        modal.fire({
          icon: error.icon,
          title: error.title,
          html: error.message,
        });
      },
    }).add(() => { this.loading = false });
  }

  protected onClose() {
    this.dialogRef.close(false);
  }
}
